<template>
  <div class="my-10">
    <PopupWrapper :platform="POPUP_TYPE.WEB_RESTAURANT" />
    <CarouselBanner
      v-if="exhibitionBanners.length > 0"
      :content="exhibitionBanners"
    ></CarouselBanner>
    <PosterBannerSmall v-if="exhibitionSmallPosters.length > 0" :content="exhibitionSmallPosters">
    </PosterBannerSmall>
    <div class="mt-2 grid grid-cols-2 gap-2 max-md:grid-cols-1">
      <SquarePosterBanner
        v-if="exhibitionPoster1.length > 0"
        :content="exhibitionPoster1"
      ></SquarePosterBanner>
      <SquarePosterBanner
        v-if="exhibitionPoster2.length > 0"
        :content="exhibitionPoster2"
      ></SquarePosterBanner>
    </div>

    <div v-if="restaurants.length > 0" class="mt-5 mb-20">
      <h2 class="text-black text-4xl font-bold">{{ $t('nav.restaurants') }}</h2>

      <div
        class="mt-5 grid grid-cols-4 gap-8 max-lg:grid-cols-3 max-lg:gap-5 max-md:grid-cols-2 max-md:gap-4"
      >
        <router-link
          v-for="item in restaurants"
          :key="item.id"
          :to="{ name: 'foodRestaurantDetail', params: { id: item.id } }"
        >
          <StoreCard :detail="item"> </StoreCard>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import StoreCard from '@cmp/mall/StoreCard.vue';
import CarouselBanner from '@cmp/CarouselBanner.vue';
import PosterBannerSmall from '@cmp/PosterBannerSmall.vue';
import SquarePosterBanner from '@cmp/SquarePosterBanner.vue';
import PopupWrapper from '@/components/PopupWrapper.vue';
import { POPUP_TYPE } from '@/constants';

export default {
  name: 'foodHomePage',
  components: {
    CarouselBanner,
    PosterBannerSmall,
    SquarePosterBanner,
    StoreCard,
    PopupWrapper,
  },
  data() {
    return {
      POPUP_TYPE,
      loading: false,
      exhibitionBanners: [],
      exhibitionSmallPosters: [],
      exhibitionPoster1: [],
      exhibitionPoster2: [],
      restaurants: [],
    };
  },
  methods: {
    async getRestaurants() {
      try {
        const response = await api.get('exhibition/stores/', {
          params: { subscription: 1, location: this.getLocation.id },
        });
        this.restaurants = response.data.results;
      } catch (e) {
        console.log(e);
      }
    },
    async getExhibitionBanner() {
      try {
        const response = await api.get('commercials/advertisements/', {
          params: { type: 218, location: this.getLocation.id },
        });
        this.exhibitionBanners = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getExhibitionPoster() {
      try {
        const response = await api.get('commercials/advertisements/', {
          params: { type: 219, location: this.getLocation.id },
        });
        let data = response.data;
        this.exhibitionPoster1 = data.filter(el => el.group_number === 1);
        this.exhibitionPoster2 = data.filter(el => el.group_number === 2);
      } catch (e) {
        console.log(e);
      }
    },
    async getExhibitionSmallPoster() {
      try {
        const response = await api.get('commercials/advertisements/', {
          params: { type: 220, location: this.getLocation.id },
        });
        this.exhibitionSmallPosters = response.data;
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    getLocation() {
      return JSON.parse(localStorage.getItem('selectedLocation')) || 1;
    },
  },
  async created() {
    await this.getRestaurants();
    await this.getExhibitionBanner();
    await this.getExhibitionPoster();
    await this.getExhibitionSmallPoster();
  },
};
</script>
